const mapSearchParams = (params: URLSearchParams) => {
    const filters: Record<string, any> = {};
    for (const [key, value] of params.entries()) {
        filters[key] = value;
    }

    return filters;
};

export { mapSearchParams };
